import React, {useEffect, useState} from "react";
import * as CONSTANT from "constants/text";
import "containers/Spotlight/MySpotlight.css";
import "components/Spotlight/Spotlight_Common.css";
import "components/General/Form/CustomButton/TwoButtonLayout.css";
import "containers/ProjectCommon.css";
import ProfileInfo from "components/Spotlight/ProfileInfo";
import ProfileDetails from "components/Spotlight/ProfileDetails";
import CompletedProjects from "components/Spotlight/CompletedProjects";
import TreasureTrove from "components/Spotlight/TreasureTrove";
import VerticalSpotlightDetails from "components/Spotlight/VerticalSpotlightDetails";
import CollapseComponent from "components/Spotlight/CollapseComponent";
import UserProfileDetailTabs from "components/Spotlight/UserProfileDetailTabs";
import UserAlbum from "components/Spotlight/Album/UserAlbum";
import AlbumComingSoon from "containers/AlbumComingSoon";
import ImpactComingSoon from "containers/ImpactComingSoon";

function TabChange (props) {
    const [tab,setTab] = useState(0);
    useEffect(() => {setTab(props.num)},[props.num]);
    if (tab === 2) {
        return (
            <section>
                <div className="impact-content d-flex" style={{ marginTop: '85px', justifyContent: 'center' }}>
                    <ImpactComingSoon />
                </div>
                <div className= "display-none album-content">
                    <UserAlbum/>
                </div>

                <div className = "display-none about-me-content">
                    <ProfileDetails/>
                    <CompletedProjects/>
                    <TreasureTrove/>
                </div>
            </section>
        );
    }
    else if (tab === 3) {
        return (
            <section>
                <div className= "impact-content display-none" style={{textAlign: "center"}}>
                    <div className="mb-15 w-100 content_spotlight-info">
                        <CollapseComponent title="My Social Impact" />
                    </div>
                </div>
                <div className= "d-flex album-content" style={{ marginTop: '85px',justifyContent:'center'}}>
                    <AlbumComingSoon/>
                </div>

                <div className = "display-none about-me-content">
                    <ProfileDetails/>
                    <CompletedProjects/>
                    <TreasureTrove/>
                </div>
            </section>
        );
    }
    else {
        return (
            <section>
                <div className= "impact-content display-none" style={{textAlign: "center"}}>
                    <div className="mb-15 w-100 content_spotlight-info">
                        <CollapseComponent title="My Social Impact" />
                    </div>
                </div>
                <div className= "display-none album-content">
                    <UserAlbum/>
                </div>

                <div style={{ marginTop:'68px'}}>
                    <ProfileDetails/>
                    <CompletedProjects/>
                    <TreasureTrove/>
                </div>
            </section>
        );
    }
}

class MySpotlight extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentToggle: 1,
        }
        this.setToggleClick = this.setToggleClick.bind(this);
        this.renderProfileTabToggle = this.renderProfileTabToggle.bind(this);
    }
    /**
     * Used to set the new current toggle. Base code from FriendUserProfile.js
     */
    setToggleClick = (toggleIndex) => {
        /*Toggle index 1 is About Me*/
        if (toggleIndex === 1) {
            this.setState(() => ({currentToggle: 1}));
        } else if (toggleIndex === 2) {
            /*Toggle index 2 is Impact*/
            this.setState(()=> ({currentToggle: 2}));
        } else if (toggleIndex === 3) {
            /*Toggle index 3 is Album*/
            this.setState(() => ({currentToggle: 3}));
        }
    }

    renderProfileTabToggle= () => {
        /*Toggle index 1 is About Me*/
        if (this.state.currentToggle === 1) {
            return (
                <UserProfileDetailTabs
                    firstButtonIsActive="true"
                    secondButtonIsActive="false"
                    thirdButtonIsActive="false"
                    firstButtonText={CONSTANT.ABOUT_ME}
                    secondButtonText={CONSTANT.IMPACT}
                    thirdButtonText={CONSTANT.ALBUM}
                    firstButtonClick={() => this.setToggleClick(1)}
                    secondButtonClick={() => this.setToggleClick(2)}
                    thirdButtonClick={() => this.setToggleClick(3)}
                />
            );
        } else if (this.state.currentToggle === 2) {
            /*Toggle index 2 is Impact*/
            return (
                <UserProfileDetailTabs
                    firstButtonIsActive="false"
                    secondButtonIsActive="true"
                    thirdButtonIsActive="false"
                    firstButtonText={CONSTANT.ABOUT_ME}
                    secondButtonText={CONSTANT.IMPACT}
                    thirdButtonText={CONSTANT.ALBUM}
                    firstButtonClick={() => this.setToggleClick(1)}
                    secondButtonClick={() => this.setToggleClick(2)}
                    thirdButtonClick={() => this.setToggleClick(3)}
                />
            );
        } else if (this.state.currentToggle === 3) {
            /*Toggle index 3 is Album*/
            return (
                <UserProfileDetailTabs
                    firstButtonIsActive="false"
                    secondButtonIsActive="false"
                    thirdButtonIsActive="true"
                    firstButtonText={CONSTANT.ABOUT_ME}
                    secondButtonText={CONSTANT.IMPACT}
                    thirdButtonText={CONSTANT.ALBUM}
                    firstButtonClick={() => this.setToggleClick(1)}
                    secondButtonClick={() => this.setToggleClick(2)}
                    thirdButtonClick={() => this.setToggleClick(3)}
                />
            );
        }
    }



    render(){
    return (
     <div className="header_main main_spotlight">
         <div className="page_main main_page">
            <div id="vertical_spotlight_details">
                <VerticalSpotlightDetails isSpotlightPage={false} />
            </div>
            <div className="page_details_main">
                <ProfileInfo />
                {this.renderProfileTabToggle()}
                <TabChange num = {this.state.currentToggle}/>
            </div>
        </div>
     </div>
    );
  }
}

export default MySpotlight;
